// Batch 3: Latvian (lv), Lithuanian (lt), Maltese (mt), Portuguese (pt),
// Swedish (sv), Slovak (sk).
// Merged into the main translations object via translations.js.

export const EXTRA_LANG_TRANSLATIONS_3 = {
    // ---------------- HEADER ----------------
    header_tagline: {
        lv: "Ārkārtas situācijā vienmēr vispirms",
        lt: "Avarinėje situacijoje visada pirmiausia",
        mt: "F'emerġenza dejjem l-ewwel",
        pt: "Em emergência, sempre primeiro",
        sv: "I en nödsituation alltid först",
        sk: "V núdzi vždy najprv",
    },
    header_emergency_number: {
        lv: "Glābšanas dienests {num}",
        lt: "Gelbėjimo tarnyba {num}",
        mt: "Servizz ta' emerġenza {num}",
        pt: "Serviço de emergência {num}",
        sv: "Räddningstjänst {num}",
        sk: "Záchranná služba {num}",
    },
    header_scan_call: {
        lv: "Scan & Call",
        lt: "Scan & Call",
        mt: "Scan & Call",
        pt: "Scan & Call",
        sv: "Scan & Call",
        sk: "Scan & Call",
    },
    header_qr_hint: {
        lv: "Ārkārtas palīdzība ar QR",
        lt: "Skubi pagalba per QR",
        mt: "Għajnuna ta' emerġenza permezz tal-QR",
        pt: "Ajuda de emergência por QR",
        sv: "Akuthjälp via QR",
        sk: "Núdzová pomoc cez QR",
    },
    header_clear_location: {
        lv: "Dzēst saglabāto atrašanās vietu",
        lt: "Pašalinti išsaugotą vietą",
        mt: "Ħassar il-lokazzjoni mfakkra",
        pt: "Limpar localização guardada",
        sv: "Rensa sparad plats",
        sk: "Vymazať uloženú polohu",
    },

    // ---------------- LANGUAGE PICKER ----------------
    language_label: {
        lv: "Valoda",
        lt: "Kalba",
        mt: "Lingwa",
        pt: "Idioma",
        sv: "Språk",
        sk: "Jazyk",
    },

    // ---------------- LANDING ----------------
    landing_emergency_title: {
        lv: "Ārkārtas situācija?",
        lt: "Avarinė situacija?",
        mt: "Emerġenza?",
        pt: "Emergência?",
        sv: "Nödsituation?",
        sk: "Núdzová situácia?",
    },
    landing_emergency_sub: {
        lv: "Sāc balsi vadītu palīdzību.",
        lt: "Pradėkite balsu valdomą pagalbą.",
        mt: "Ibda l-għajnuna mmexxija bil-vuċi.",
        pt: "Inicie a ajuda guiada por voz.",
        sv: "Starta den röststyrda hjälpen.",
        sk: "Spustite hlasom vedenú pomoc.",
    },
    landing_demo_label: {
        lv: "Demo",
        lt: "Demo",
        mt: "Demo",
        pt: "Demo",
        sv: "Demo",
        sk: "Demo",
    },
    landing_demo_title: {
        lv: "Man nav ārkārtas situācijas, bet vēlos redzēt, kā tas darbojas.",
        lt: "Neturiu avarinės situacijos, bet noriu pamatyti, kaip tai veikia.",
        mt: "M'għandix emerġenza imma rrid nara kif jaħdem.",
        pt: "Não tenho uma emergência, mas quero ver como funciona.",
        sv: "Jag har ingen nödsituation men vill se hur det fungerar.",
        sk: "Nemám núdzovú situáciu, ale chcem vidieť, ako to funguje.",
    },
    landing_demo_sub: { lv: "", lt: "", mt: "", pt: "", sv: "", sk: "" },
    landing_aed_button: {
        lv: "Atvērt defibrilatora karti",
        lt: "Atidaryti defibriliatoriaus žemėlapį",
        mt: "Iftaħ il-mappa tad-defibrillaturi",
        pt: "Abrir mapa de desfibrilhadores",
        sv: "Öppna defibrillatorkarta",
        sk: "Otvoriť mapu defibrilátorov",
    },
    landing_aed_button_sub: {
        lv: "Atrast defibrilatorus tuvumā",
        lt: "Raskite defibriliatorius netoliese",
        mt: "Sib defibrillaturi fil-qrib",
        pt: "Encontrar desfibrilhadores próximos",
        sv: "Hitta defibrillatorer i närheten",
        sk: "Nájdite defibrilátory v okolí",
    },
    landing_disclaimer_full: {
        lv: "Sniegtā informācija kalpo tikai kā vadlīnija. Lietošana notiek uz jūsu pašu risku un neaizstāj jūsu pašu situācijas izvērtējumu vai profesionālus norādījumus uz vietas. Nav garantijas par precizitāti. Šaubu gadījumā vienmēr zvaniet {notruf}.",
        lt: "Pateikta informacija yra tik orientacinė. Naudojimas yra jūsų pačių rizika ir nepakeičia jūsų pačių padėties įvertinimo ar profesionalių nurodymų vietoje. Garantijos dėl tikslumo nėra. Esant abejonėms visada skambinkite {notruf}.",
        mt: "L-informazzjoni provduta sservi biss bħala gwida. L-użu huwa fuq ir-riskju tiegħek u ma jissostitwixxix il-ġudizzju tas-sitwazzjoni tiegħek jew l-istruzzjonijiet professjonali fuq il-post. L-ebda garanzija ta' eżattezza. F'każ ta' dubju dejjem ċempel {notruf}.",
        pt: "As informações fornecidas servem apenas como orientação. O uso é por sua conta e risco e não substitui a sua avaliação da situação ou instruções profissionais no local. Sem garantia de exatidão. Em caso de dúvida ligue sempre para o {notruf}.",
        sv: "Informationen är endast vägledande. Användning sker på egen risk och ersätter inte din egen lägesbedömning eller professionella instruktioner på plats. Ingen garanti för riktighet. Vid tvivel ring alltid {notruf}.",
        sk: "Poskytnuté informácie slúžia len ako orientácia. Použitie je na vlastné riziko a nenahrádza vlastné posúdenie situácie ani profesionálne pokyny na mieste. Bez záruky správnosti. V prípade pochybností vždy volajte {notruf}.",
    },
    landing_disclaimer_notruf: {
        lv: "ārkārtas numurs {num}",
        lt: "pagalbos numeris {num}",
        mt: "numru ta' emerġenza {num}",
        pt: "número de emergência {num}",
        sv: "nödnummer {num}",
        sk: "tiesňové číslo {num}",
    },
    landing_unsure_full: {
        lv: "Šaubies? Šaubu gadījumā veic {notruf}!",
        lt: "Nesate tikri? Esant abejonėms atlikite {notruf}!",
        mt: "Mhux ċert? F'każ ta' dubju agħmel {notruf}!",
        pt: "Em dúvida? Na dúvida, faça uma {notruf}!",
        sv: "Osäker? Vid tvivel, gör ett {notruf}!",
        sk: "Nie ste si istý? V prípade pochybností uskutočnite {notruf}!",
    },
    landing_unsure_notruf: {
        lv: "ārkārtas zvans",
        lt: "skubus skambutis",
        mt: "sejħa ta' emerġenza",
        pt: "chamada de emergência",
        sv: "nödsamtal",
        sk: "tiesňové volanie",
    },
    landing_skip_to_cpr: {
        lv: "Pāriet uzreiz uz reanimāciju",
        lt: "Pereiti tiesiai prie gaivinimo",
        mt: "Aqbeż dritt għar-risuxitazzjoni",
        pt: "Saltar diretamente para a reanimação",
        sv: "Hoppa direkt till HLR",
        sk: "Preskočiť priamo na resuscitáciu",
    },
    landing_skip_to_cpr_sub: {
        lv: "Demo režīmā, bez triāžas jautājumiem.",
        lt: "Demonstraciniame režime, be triažo klausimų.",
        mt: "F'modalità demo, mingħajr mistoqsijiet ta' triage.",
        pt: "Em modo demo, sem perguntas de triagem.",
        sv: "I demoläge, utan triagefrågor.",
        sk: "V demo režime, bez triage otázok.",
    },
    footer_privacy: {
        lv: "Privātums",
        lt: "Privatumas",
        mt: "Privatezza",
        pt: "Privacidade",
        sv: "Integritet",
        sk: "Súkromie",
    },
    footer_imprint: {
        lv: "Impresums",
        lt: "Įmonės duomenys",
        mt: "Impressum",
        pt: "Ficha técnica",
        sv: "Impressum",
        sk: "Tiráž",
    },

    // ---------------- SCAN & CALL BANNER ----------------
    scancall_title: {
        lv: "Mēs digitalizējam glābšanas ķēdi.",
        lt: "Skaitmeniname gelbėjimo grandinę.",
        mt: "Qed nagħmlu l-katina tas-salvataġġ diġitali.",
        pt: "Estamos a digitalizar a cadeia de socorro.",
        sv: "Vi digitaliserar räddningskedjan.",
        sk: "Digitalizujeme záchrannú reťaz.",
    },
    scancall_sub: {
        lv: "Pirmās palīdzības plakāts dažās minūtēs – atbilst DGUV un mūžīgi bez maksas.",
        lt: "Pirmosios pagalbos plakatas per kelias minutes – atitinka DGUV ir nemokamai visą gyvenimą.",
        mt: "Poster tal-ewwel għajnuna f'minuti – konformi mad-DGUV u b'xejn għal dejjem.",
        pt: "Cartaz de primeiros socorros em minutos – conforme com DGUV e grátis para sempre.",
        sv: "Första hjälpen-affisch på minuter – DGUV-kompatibel och livstidsgratis.",
        sk: "Plagát prvej pomoci za pár minút – v súlade s DGUV a doživotne zadarmo.",
    },
    scancall_bullet_1: {
        lv: "Ārkārtas zvans, pirmie palīgi un atrašanās vieta uzreiz",
        lt: "Skubus skambutis, pirmieji pagalbininkai ir vieta vienu žvilgsniu",
        mt: "Sejħa ta' emerġenza, l-ewwel rispondituri u lokazzjoni f'daqqa t'għajn",
        pt: "Chamada de emergência, primeiros socorristas e localização num relance",
        sv: "Nödsamtal, första hjälpare och plats med en blick",
        sk: "Tiesňové volanie, prví záchranári a poloha na prvý pohľad",
    },
    scancall_bullet_2: {
        lv: "Tieši uz viedtālruni ar QR kodu",
        lt: "Tiesiai į išmanųjį telefoną per QR kodą",
        mt: "Direttament fuq l-iSmartphone permezz ta' kodiċi QR",
        pt: "Diretamente para o smartphone via código QR",
        sv: "Direkt till smartphonen via QR-kod",
        sk: "Priamo do smartfónu cez QR kód",
    },
    scancall_bullet_3: {
        lv: "DGUV atbilstošs plakāts – uzreiz lietošanai gatavs",
        lt: "DGUV atitinkantis plakatas – iškart parengtas naudoti",
        mt: "Poster konformi mad-DGUV – lest għall-użu immedjatament",
        pt: "Cartaz conforme DGUV – pronto a usar imediatamente",
        sv: "DGUV-kompatibel affisch – klar att använda direkt",
        sk: "Plagát v súlade s DGUV – okamžite pripravený na použitie",
    },
    scancall_cta: {
        lv: "Sākt tagad",
        lt: "Pradėti dabar",
        mt: "Ibda issa",
        pt: "Começar agora",
        sv: "Starta nu",
        sk: "Začať teraz",
    },

    // ---------------- EMAIL POPUP ----------------
    email_popup_title: {
        lv: "Esi informēts",
        lt: "Likite informuoti",
        mt: "Ibqa' aġġornat",
        pt: "Fica a par",
        sv: "Håll dig uppdaterad",
        sk: "Zostaňte v obraze",
    },
    email_popup_body: {
        lv: "Prieks, ka izmēģini SafetyAssist. Mēs nepārtraukti uzlabojam šo ārkārtas palīdzību. Atstāj savu e-pastu, lai saņemtu atjauninājumus, tiklīdz parādīsies jaunas funkcijas.",
        lt: "Smagu, kad išbandote SafetyAssist. Šią pagalbą nuolat tobuliname. Palikite savo el. paštą, kad gautumėte atnaujinimus, kai pasirodys naujos funkcijos.",
        mt: "Grati li qed tipprova SafetyAssist. Qed ittejjeb din l-għajnuna ta' emerġenza kontinwament. Ħalli l-email tiegħek biex tirċievi aġġornamenti hekk kif jaslu funzjonijiet ġodda.",
        pt: "Que bom que está a experimentar o SafetyAssist. Continuamos a melhorar esta ajuda de emergência. Deixe o seu e-mail para receber atualizações assim que houver novas funcionalidades.",
        sv: "Kul att du provar SafetyAssist. Vi förbättrar denna nödhjälp ständigt. Lämna din e-post för att få uppdateringar så snart nya funktioner finns.",
        sk: "Sme radi, že skúšate SafetyAssist. Túto núdzovú pomoc neustále vylepšujeme. Zanechajte svoj e-mail a dostanete novinky hneď, ako budú nové funkcie.",
    },
    email_popup_email_placeholder: {
        lv: "tu@email.lv",
        lt: "jus@email.lt",
        mt: "inti@email.mt",
        pt: "voce@email.pt",
        sv: "du@email.se",
        sk: "ty@email.sk",
    },
    email_popup_consent: {
        lv: "Iesniedzot piekrītu, ka mans e-pasts tiek saglabāts un izmantots SafetyAssist atjauninājumu sūtīšanai.",
        lt: "Pateikdamas (-a) sutinku, kad mano el. pašto adresas būtų išsaugotas ir naudojamas SafetyAssist atnaujinimams siųsti.",
        mt: "Bil-bgħit naqbel li l-indirizz tal-email tiegħi jinżamm u jintuża biex jintbagħtu aġġornamenti ta' SafetyAssist.",
        pt: "Ao enviar concordo que o meu endereço de e-mail seja guardado e usado para enviar atualizações do SafetyAssist.",
        sv: "Genom att skicka godkänner jag att min e-postadress sparas och används för att skicka SafetyAssist-uppdateringar.",
        sk: "Odoslaním súhlasím s uložením mojej e-mailovej adresy a jej použitím na zasielanie noviniek SafetyAssist.",
    },
    email_popup_submit: {
        lv: "Pierakstīties",
        lt: "Užsisakyti",
        mt: "Issieħeb",
        pt: "Subscrever",
        sv: "Prenumerera",
        sk: "Prihlásiť sa",
    },
    email_popup_later: {
        lv: "Varbūt vēlāk",
        lt: "Galbūt vėliau",
        mt: "Forsi aktar tard",
        pt: "Talvez mais tarde",
        sv: "Kanske senare",
        sk: "Možno neskôr",
    },
    email_popup_thanks: {
        lv: "Paldies! Sazināsimies, tiklīdz būs jaunumi.",
        lt: "Ačiū! Susisieksime vos atsiradus naujienoms.",
        mt: "Grazzi! Inkellmuk hekk kif ikun hemm aħbarijiet.",
        pt: "Obrigado! Entraremos em contacto assim que houver novidades.",
        sv: "Tack! Vi hör av oss så snart det finns nyheter.",
        sk: "Ďakujeme! Ozveme sa hneď, ako budú novinky.",
    },
    email_popup_error_email: {
        lv: "Lūdzu, ievadi derīgu e-pasta adresi.",
        lt: "Įveskite galiojantį el. pašto adresą.",
        mt: "Jekk jogħġbok daħħal indirizz tal-email validu.",
        pt: "Insira um endereço de e-mail válido.",
        sv: "Ange en giltig e-postadress.",
        sk: "Zadajte platnú e-mailovú adresu.",
    },
    email_popup_error_consent: {
        lv: "Lūdzu, piekrīti sava e-pasta saglabāšanai.",
        lt: "Sutikite, kad jūsų el. paštas būtų saugomas.",
        mt: "Jekk jogħġbok aqbel li l-email tiegħek tiġi maħżuna.",
        pt: "Concorde com o armazenamento do seu endereço de e-mail.",
        sv: "Godkänn att din e-postadress sparas.",
        sk: "Súhlaste s uložením vašej e-mailovej adresy.",
    },

    // ---------------- SAFETY BRIEFING ----------------
    safety_title: {
        lv: "Drošības norādījumi",
        lt: "Saugumo nurodymai",
        mt: "Istruzzjonijiet tas-sigurtà",
        pt: "Instruções de segurança",
        sv: "Säkerhetsanvisningar",
        sk: "Bezpečnostné pokyny",
    },
    safety_line_1: {
        lv: "Saglabā mieru!",
        lt: "Likite ramūs!",
        mt: "Ibqa' kalm!",
        pt: "Mantenha a calma!",
        sv: "Var lugn!",
        sk: "Zachovajte pokoj!",
    },
    safety_line_2: {
        lv: "Nodrošini negadījuma vietu!",
        lt: "Apsaugokite įvykio vietą!",
        mt: "Iżgura l-post tal-inċident!",
        pt: "Proteja o local do acidente!",
        sv: "Säkra olycksplatsen!",
        sk: "Zabezpečte miesto nehody!",
    },
    safety_line_3: {
        lv: "Domā par savu drošību.",
        lt: "Atsižvelkite į savo saugumą.",
        mt: "Oqgħod attent għas-sigurtà tiegħek.",
        pt: "Cuide da sua própria segurança.",
        sv: "Tänk på din egen säkerhet.",
        sk: "Dbajte na vlastnú bezpečnosť.",
    },
    safety_line_4: {
        lv: "Ja nepieciešams, izved cilvēku no bīstamās zonas.",
        lt: "Jei reikia, ištraukite žmogų iš pavojaus zonos.",
        mt: "Jekk meħtieġ, neħħi l-persuna miż-żona ta' periklu.",
        pt: "Se necessário, retire a pessoa da zona de perigo.",
        sv: "Vid behov, flytta personen ur farozonen.",
        sk: "V prípade potreby vyveďte osobu z nebezpečnej zóny.",
    },
    safety_hint: {
        lv: "Tu neesi viens – {num} augšā vienmēr pieejams.",
        lt: "Esate ne vienas – {num} viršuje visada pasiekiamas.",
        mt: "M'intix waħdek – {num} fuq fuq dejjem aċċessibbli.",
        pt: "Não está sozinho – {num} no topo está sempre acessível.",
        sv: "Du är inte ensam – {num} högst upp nås alltid.",
        sk: "Nie ste sami – {num} hore je vždy dostupný.",
    },
    safety_continue: {
        lv: "Tālāk",
        lt: "Toliau",
        mt: "Kompli",
        pt: "Continuar",
        sv: "Fortsätt",
        sk: "Pokračovať",
    },

    // ---------------- TRIAGE ----------------
    triage_assessment: {
        lv: "Sākotnējais novērtējums",
        lt: "Pradinis vertinimas",
        mt: "Valutazzjoni inizjali",
        pt: "Avaliação inicial",
        sv: "Initial bedömning",
        sk: "Prvotné posúdenie",
    },
    triage_demo_badge: {
        lv: "Demo",
        lt: "Demo",
        mt: "Demo",
        pt: "Demo",
        sv: "Demo",
        sk: "Demo",
    },
    triage_check_person: {
        lv: "Pārbaudi personu",
        lt: "Patikrinkite asmenį",
        mt: "Iċċekkja l-persuna",
        pt: "Verifique a pessoa",
        sv: "Kontrollera personen",
        sk: "Skontrolujte osobu",
    },
    triage_question_label: {
        lv: "Jautājums",
        lt: "Klausimas",
        mt: "Mistoqsija",
        pt: "Pergunta",
        sv: "Fråga",
        sk: "Otázka",
    },
    triage_consciousness_title: {
        lv: "Vai persona ir pie samaņas?",
        lt: "Ar asmuo sąmoningas?",
        mt: "Il-persuna f'sensiha?",
        pt: "A pessoa está consciente?",
        sv: "Är personen vid medvetande?",
        sk: "Je osoba pri vedomí?",
    },
    triage_consciousness_sub: {
        lv: "Reaģē",
        lt: "Reaguoja",
        mt: "Tirreaġixxi",
        pt: "Responsivo",
        sv: "Reagerar",
        sk: "Reaguje",
    },
    triage_consciousness_tts: {
        lv: "Vai persona ir pie samaņas? Vai tā reaģē?",
        lt: "Ar asmuo sąmoningas? Ar jis reaguoja?",
        mt: "Il-persuna f'sensiha? Qed tirreaġixxi?",
        pt: "A pessoa está consciente? Está a responder?",
        sv: "Är personen vid medvetande? Reagerar hon?",
        sk: "Je osoba pri vedomí? Reaguje?",
    },
    triage_advice_conscious_title: {
        lv: "Palīdzi atbilstoši situācijai",
        lt: "Padėkite pagal situaciją",
        mt: "Għin skont is-sitwazzjoni",
        pt: "Ajude conforme a situação",
        sv: "Hjälp efter situationen",
        sk: "Pomôžte podľa situácie",
    },
    triage_advice_conscious_body: {
        lv: "piem., apkop brūci, nomierini personu, aizsargā no atdzišanas.",
        lt: "pvz., aptvarstykite žaizdą, nuraminkite asmenį, apsaugokite nuo peršalimo.",
        mt: "eż. ikkura l-feriti, ikkalma l-persuna, ipproteġi mill-ipotermija.",
        pt: "ex.: tratar ferimentos, acalmar a pessoa, proteger da hipotermia.",
        sv: "t.ex. behandla sår, lugna personen, skydda mot nedkylning.",
        sk: "napr. ošetrite ranu, upokojte osobu, chráňte pred podchladením.",
    },
    triage_advice_conscious_tts: {
        lv: "Palīdzi atbilstoši situācijai, piemēram, apkop brūci. Pēc tam nospied lielo sarkano ārkārtas pogu.",
        lt: "Padėkite pagal situaciją, pavyzdžiui, aptvarstykite žaizdą. Tada paspauskite didelį raudoną pagalbos mygtuką.",
        mt: "Għin skont is-sitwazzjoni, pereżempju ikkura l-feriti. Imbagħad agħfas il-buttuna l-kbira ħamra ta' emerġenza.",
        pt: "Ajude conforme a situação, por exemplo, trate as feridas. Em seguida pressione o grande botão vermelho de emergência.",
        sv: "Hjälp efter situationen, till exempel behandla sår. Tryck sedan på den stora röda nödknappen.",
        sk: "Pomôžte podľa situácie, napríklad ošetrite ranu. Potom stlačte veľké červené tiesňové tlačidlo.",
    },
    triage_breathing_title: {
        lv: "Vai persona elpo?",
        lt: "Ar asmuo kvėpuoja?",
        mt: "Il-persuna qed tieħu n-nifs?",
        pt: "A pessoa está a respirar?",
        sv: "Andas personen?",
        sk: "Dýcha osoba?",
    },
    triage_breathing_sub: {
        lv: "Skaties, klausies, jūti",
        lt: "Žiūrėkite, klausykite, jauskite",
        mt: "Ħares, isma', ħoss",
        pt: "Veja, ouça, sinta",
        sv: "Se, lyssna, känn",
        sk: "Pozerajte, počúvajte, cíťte",
    },
    triage_breathing_tts: {
        lv: "Vai persona elpo? Pārbaudi, skatoties, klausoties un sajūtot.",
        lt: "Ar asmuo kvėpuoja? Patikrinkite žiūrėdami, klausydamiesi ir jausdami.",
        mt: "Il-persuna qed tieħu n-nifs? Iċċekkja billi tħares, tisma' u tħoss.",
        pt: "A pessoa está a respirar? Verifique olhando, ouvindo e sentindo.",
        sv: "Andas personen? Kontrollera genom att se, lyssna och känna.",
        sk: "Dýcha osoba? Skontrolujte zrakom, sluchom a hmatom.",
    },
    triage_advice_breathing_title: {
        lv: "Stabilais sānu stāvoklis",
        lt: "Stabili šoninė padėtis",
        mt: "Pożizzjoni ta' rkupru",
        pt: "Posição lateral de segurança",
        sv: "Stabilt sidoläge",
        sk: "Stabilizovaná poloha na boku",
    },
    triage_advice_breathing_body: {
        lv: "Novieto personu stabilā sānu stāvoklī un uzraugi elpošanu.",
        lt: "Paguldykite asmenį į stabilią šoninę padėtį ir stebėkite kvėpavimą.",
        mt: "Poġġi l-persuna fil-pożizzjoni ta' rkupru u sorvelja n-nifs.",
        pt: "Coloque a pessoa em posição lateral de segurança e monitorize a respiração.",
        sv: "Lägg personen i stabilt sidoläge och övervaka andningen.",
        sk: "Uložte osobu do stabilizovanej polohy na boku a sledujte dýchanie.",
    },
    triage_advice_breathing_tts: {
        lv: "Novieto personu stabilā sānu stāvoklī. Pēc tam nospied lielo sarkano ārkārtas pogu.",
        lt: "Paguldykite asmenį į stabilią šoninę padėtį. Tada paspauskite didelį raudoną pagalbos mygtuką.",
        mt: "Poġġi l-persuna fil-pożizzjoni ta' rkupru. Imbagħad agħfas il-buttuna l-kbira ħamra ta' emerġenza.",
        pt: "Coloque a pessoa em posição lateral de segurança. Em seguida pressione o grande botão vermelho de emergência.",
        sv: "Lägg personen i stabilt sidoläge. Tryck sedan på den stora röda nödknappen.",
        sk: "Uložte osobu do stabilizovanej polohy na boku. Potom stlačte veľké červené tiesňové tlačidlo.",
    },
    triage_advice_no_breath_title: {
        lv: "Nav samaņas un elpas – Zvani nekavējoties",
        lt: "Nėra sąmonės ir kvėpavimo – Skambinkite nedelsdami",
        mt: "Bla sensi u bla nifs – Ċempel mill-ewwel",
        pt: "Sem consciência e sem respiração – Chame agora",
        sv: "Ingen medvetenhet och ingen andning – Ring nödnumret nu",
        sk: "Bez vedomia a bez dychu – Okamžite volajte",
    },
    triage_advice_no_breath_body: {
        lv: "Nekavējoties zvani {num} un sāc krūškurvja kompresijas (30:2).",
        lt: "Nedelsdami skambinkite {num} ir pradėkite krūtinės paspaudimus (30:2).",
        mt: "Ċempel {num} immedjatament u ibda kompressjonijiet tas-sider (30:2).",
        pt: "Ligue imediatamente para o {num} e inicie compressões torácicas (30:2).",
        sv: "Ring {num} omedelbart och börja bröstkompressioner (30:2).",
        sk: "Okamžite volajte {num} a začnite stláčanie hrudníka (30:2).",
    },
    triage_advice_no_breath_tts: {
        lv: "Nav samaņas un nav elpas. Nekavējoties nospied lielo sarkano ārkārtas pogu un sāc reanimāciju.",
        lt: "Nėra sąmonės ir nėra kvėpavimo. Nedelsdami paspauskite didelį raudoną pagalbos mygtuką ir pradėkite gaivinimą.",
        mt: "Bla sensi u bla nifs. Agħfas immedjatament il-buttuna l-kbira ħamra ta' emerġenza u ibda r-risuxitazzjoni.",
        pt: "Sem consciência e sem respiração. Pressione imediatamente o grande botão vermelho de emergência e inicie a reanimação.",
        sv: "Ingen medvetenhet och ingen andning. Tryck omedelbart på den stora röda nödknappen och starta HLR.",
        sk: "Bez vedomia a bez dychu. Okamžite stlačte veľké červené tiesňové tlačidlo a začnite resuscitáciu.",
    },
    triage_yes: {
        lv: "Jā",
        lt: "Taip",
        mt: "Iva",
        pt: "Sim",
        sv: "Ja",
        sk: "Áno",
    },
    triage_no: {
        lv: "Nē",
        lt: "Ne",
        mt: "Le",
        pt: "Não",
        sv: "Nej",
        sk: "Nie",
    },
    triage_advice_label: {
        lv: "Ieteikums",
        lt: "Rekomendacija",
        mt: "Rakkomandazzjoni",
        pt: "Recomendação",
        sv: "Rekommendation",
        sk: "Odporúčanie",
    },
    triage_emergency_call: {
        lv: "Ārkārtas {num}",
        lt: "Pagalba {num}",
        mt: "Emerġenza {num}",
        pt: "Emergência {num}",
        sv: "Nödsamtal {num}",
        sk: "Tieseň {num}",
    },
    triage_demo_alert_urgent: {
        lv: "Reālā ārkārtas situācijā šeit tiktu sākts zvans uz {num}.",
        lt: "Tikroje avarinėje situacijoje čia būtų inicijuotas skambutis numeriu {num}.",
        mt: "F'emerġenza vera, hawn tinbeda s-sejħa lil {num}.",
        pt: "Numa emergência real, aqui seria iniciada a chamada para {num}.",
        sv: "I en verklig nödsituation skulle samtalet till {num} startas här.",
        sk: "V skutočnej núdzi by sa tu spustilo volanie na {num}.",
    },
    triage_demo_alert_generic: {
        lv: "Reālā ārkārtas situācijā šeit tiktu sākts zvans uz {num}.",
        lt: "Tikroje avarinėje situacijoje čia būtų inicijuotas skambutis numeriu {num}.",
        mt: "F'emerġenza vera, hawn tinbeda s-sejħa lil {num}.",
        pt: "Numa emergência real, aqui seria iniciada a chamada para {num}.",
        sv: "I en verklig nödsituation skulle samtalet till {num} startas här.",
        sk: "V skutočnej núdzi by sa tu spustilo volanie na {num}.",
    },
    breadcrumb_conscious_no: {
        lv: "Nav samaņas",
        lt: "Be sąmonės",
        mt: "Mhux f'sensih",
        pt: "Sem consciência",
        sv: "Ingen medvetenhet",
        sk: "Bez vedomia",
    },
    breadcrumb_conscious_yes: {
        lv: "Pie samaņas",
        lt: "Sąmoningas",
        mt: "F'sensih",
        pt: "Consciente",
        sv: "Vid medvetande",
        sk: "Pri vedomí",
    },
    breadcrumb_breathing_no: {
        lv: "Neelpo",
        lt: "Nekvėpuoja",
        mt: "Mhux jieħu n-nifs",
        pt: "Sem respiração",
        sv: "Andas inte",
        sk: "Nedýcha",
    },
    breadcrumb_breathing_yes: {
        lv: "Elpo",
        lt: "Kvėpuoja",
        mt: "Jieħu n-nifs",
        pt: "A respirar",
        sv: "Andas",
        sk: "Dýcha",
    },
    breadcrumb_called_112: {
        lv: "Ārkārtas zvans veikts",
        lt: "Skubus skambutis atliktas",
        mt: "Sejħa ta' emerġenza saret",
        pt: "Chamada de emergência feita",
        sv: "Nödsamtal gjort",
        sk: "Tiesňové volanie uskutočnené",
    },
    demo_banner_label: {
        lv: "Demo režīms aktīvs",
        lt: "Demo režimas aktyvus",
        mt: "Modalità demo attiva",
        pt: "Modo demo ativo",
        sv: "Demoläge aktivt",
        sk: "Demo režim aktívny",
    },
    demo_tts_prefix: {
        lv: "Demo režīms.",
        lt: "Demo režimas.",
        mt: "Modalità demo.",
        pt: "Modo demo.",
        sv: "Demoläge.",
        sk: "Demo režim.",
    },

    // ---------------- CPR ----------------
    cpr_waiting_title: {
        lv: "Tiek zvanīts {num}…",
        lt: "Skambinama {num}…",
        mt: "Qed iċempel {num}…",
        pt: "A ligar {num}…",
        sv: "Ringer {num}…",
        sk: "Volá sa {num}…",
    },
    cpr_waiting_body: {
        lv: "Sazinies ar dispečeru. Tiklīdz atgriezīsies aplikācijā, vadītā reanimācija sāksies automātiski.",
        lt: "Bendraukite su dispečeriu. Kai grįšite į programą, valdomas gaivinimas prasidės automatiškai.",
        mt: "Kellem lid-dispaċċ. Hekk kif tirritorna fl-app, ir-risuxitazzjoni ggwidata tibda awtomatikament.",
        pt: "Fale com o despachante. Assim que voltar à aplicação, a reanimação guiada começa automaticamente.",
        sv: "Prata med larmoperatören. Så snart du återvänder till appen startar den guidade HLR automatiskt.",
        sk: "Hovorte s dispečerom. Hneď ako sa vrátite do aplikácie, vedená resuscitácia sa automaticky spustí.",
    },
    cpr_start_now: {
        lv: "Sākt tagad",
        lt: "Pradėti dabar",
        mt: "Ibda issa",
        pt: "Começar agora",
        sv: "Starta nu",
        sk: "Začať teraz",
    },
    cpr_intro_title: {
        lv: "Veikt reanimāciju",
        lt: "Atlikti gaivinimą",
        mt: "Wettaq ir-risuxitazzjoni",
        pt: "Realizar reanimação",
        sv: "Utför HLR",
        sk: "Vykonať resuscitáciu",
    },
    cpr_intro_body: {
        lv: "Spied 2× sekundē – 30 reizes, tad 2 elpas.",
        lt: "Spauskite 2× per sekundę – 30 kartų, tada 2 įpūtimai.",
        mt: "Agħfas 2× kull sekonda – 30 darba, imbagħad 2 nifsiet.",
        pt: "Pressione 2× por segundo – 30 vezes, depois 2 insuflações.",
        sv: "Tryck 2× per sekund – 30 gånger, sedan 2 inblåsningar.",
        sk: "Stláčajte 2× za sekundu – 30-krát, potom 2 vdychy.",
    },
    cpr_intro_tts: {
        lv: "Veic reanimāciju. Spied divreiz sekundē trīsdesmit reizes, tad veic divas elpas.",
        lt: "Atlikite gaivinimą. Spauskite du kartus per sekundę trisdešimt kartų, tada atlikite du įpūtimus.",
        mt: "Wettaq ir-risuxitazzjoni. Agħfas darbtejn kull sekonda tletin darba, imbagħad agħti żewġ nifsiet.",
        pt: "Realize a reanimação. Pressione duas vezes por segundo, trinta vezes, depois faça duas insuflações.",
        sv: "Utför HLR. Tryck två gånger per sekund, trettio gånger, ge sedan två inblåsningar.",
        sk: "Vykonajte resuscitáciu. Stláčajte dvakrát za sekundu tridsaťkrát a potom dajte dva vdychy.",
    },
    cpr_start_immediately: {
        lv: "Tālāk",
        lt: "Toliau",
        mt: "Kompli",
        pt: "Continuar",
        sv: "Fortsätt",
        sk: "Pokračovať",
    },
    cpr_active_title: {
        lv: "Veic reanimāciju!",
        lt: "Atlikite gaivinimą!",
        mt: "Wettaq is-CPR!",
        pt: "Realize CPR!",
        sv: "Utför HLR!",
        sk: "Vykonajte resuscitáciu!",
    },
    cpr_reanimation: {
        lv: "Reanimācija",
        lt: "Gaivinimas",
        mt: "Risuxitazzjoni",
        pt: "Reanimação",
        sv: "HLR",
        sk: "Resuscitácia",
    },
    cpr_counter_compressions: {
        lv: "{n}/30 spiedieni",
        lt: "{n}/30 paspaudimai",
        mt: "{n}/30 kompressjonijiet",
        pt: "{n}/30 compressões",
        sv: "{n}/30 tryck",
        sk: "{n}/30 stlačení",
    },
    cpr_counter_breaths: {
        lv: "{n}/2 elpas",
        lt: "{n}/2 įpūtimai",
        mt: "{n}/2 nifsiet",
        pt: "{n}/2 insuflações",
        sv: "{n}/2 inblåsningar",
        sk: "{n}/2 vdychy",
    },
    cpr_label_compress: {
        lv: "Spied",
        lt: "Spauskite",
        mt: "Agħfas",
        pt: "Pressionar",
        sv: "Tryck",
        sk: "Stláčajte",
    },
    cpr_label_breathe: {
        lv: "Elpo",
        lt: "Įpūskite",
        mt: "Ieħu n-nifs",
        pt: "Insuflar",
        sv: "Blås in",
        sk: "Dýchajte",
    },
    cpr_bpm_line: {
        lv: "110 BPM · 545 ms uz spiedienu",
        lt: "110 BPM · 545 ms vienam paspaudimui",
        mt: "110 BPM · 545 ms għal kull kompressjoni",
        pt: "110 BPM · 545 ms por compressão",
        sv: "110 BPM · 545 ms per tryck",
        sk: "110 BPM · 545 ms na stlačenie",
    },
    cpr_timer_suffix: {
        lv: "30× spiest · 2× elpot",
        lt: "30× spausti · 2× įpūsti",
        mt: "30× agħfas · 2× nifs",
        pt: "30× pressionar · 2× insuflar",
        sv: "30× tryck · 2× inblåsningar",
        sk: "30× stlačiť · 2× dýchnuť",
    },
    cpr_continue_hint: {
        lv: "Turpini, līdz ierodas palīdzība.",
        lt: "Tęskite, kol atvyks pagalba.",
        mt: "Kompli sakemm tasal l-għajnuna.",
        pt: "Continue até chegar ajuda.",
        sv: "Fortsätt tills hjälp anländer.",
        sk: "Pokračujte, kým nepríde pomoc.",
    },
    cpr_handover_tts: {
        lv: "Sauc pēc nomaiņas!",
        lt: "Šaukite pamainos!",
        mt: "Sejjaħ għal sostituzzjoni!",
        pt: "Peça uma substituição!",
        sv: "Kalla på avlösning!",
        sk: "Privolajte výmenu!",
    },
    cpr_breath_tts: {
        lv: "Elpo",
        lt: "Įpūskite",
        mt: "Ieħu n-nifs",
        pt: "Insuflar",
        sv: "Blås in",
        sk: "Dýchajte",
    },
    cpr_show_aed: {
        lv: "Defibrilators tuvumā",
        lt: "Defibriliatorius netoliese",
        mt: "Defibrillatur fil-qrib",
        pt: "Desfibrilhador próximo",
        sv: "Defibrillator i närheten",
        sk: "Defibrilátor v okolí",
    },

    // ---------------- AED ----------------
    aed_back: {
        lv: "Atpakaļ",
        lt: "Atgal",
        mt: "Lura",
        pt: "Voltar",
        sv: "Tillbaka",
        sk: "Späť",
    },
    aed_section_label: {
        lv: "Defibrilatora meklēšana",
        lt: "Defibriliatoriaus paieška",
        mt: "Tfittxija għal defibrillatur",
        pt: "Procura de desfibrilhador",
        sv: "Sök defibrillator",
        sk: "Hľadanie defibrilátora",
    },
    aed_confirm_title: {
        lv: "Vai joprojām esat šajā atrašanās vietā?",
        lt: "Ar vis dar esate šioje vietoje?",
        mt: "Għadek f'din il-lokazzjoni?",
        pt: "Continua nesta localização?",
        sv: "Är du fortfarande på den här platsen?",
        sk: "Ste stále na tomto mieste?",
    },
    aed_confirm_yes: {
        lv: "Jā, turpināt",
        lt: "Taip, tęsti",
        mt: "Iva, kompli",
        pt: "Sim, continuar",
        sv: "Ja, fortsätt",
        sk: "Áno, pokračovať",
    },
    aed_confirm_no: {
        lv: "Nē, jauna atrašanās vieta",
        lt: "Ne, nauja vieta",
        mt: "Le, lokazzjoni ġdida",
        pt: "Não, nova localização",
        sv: "Nej, ny plats",
        sk: "Nie, nové miesto",
    },
    aed_detecting_title: {
        lv: "Notiek atrašanās vietas noteikšana…",
        lt: "Nustatoma vieta…",
        mt: "Qed jiġi rilevat il-post…",
        pt: "A detetar localização…",
        sv: "Hämtar plats…",
        sk: "Zisťuje sa poloha…",
    },
    aed_detecting_sub: {
        lv: "Lūdzu, atļauj atrašanās vietas piekļuvi pārlūka dialogā.",
        lt: "Leiskite prieigą prie vietos naršyklės lange.",
        mt: "Ippermetti l-aċċess għall-post fid-djalogu tal-browser.",
        pt: "Permita o acesso à localização na janela do navegador.",
        sv: "Tillåt platsåtkomst i webbläsarens dialogruta.",
        sk: "Povoľte prístup k polohe v dialógu prehliadača.",
    },
    aed_detecting_hint: {
        lv: "Ja dialogs neparādās vai esi atteicies, vari arī ievadīt pasta indeksu.",
        lt: "Jei langas nepasirodo arba atsisakėte, galite įvesti pašto kodą.",
        mt: "Jekk id-djalogu ma jidhirx jew tirrifjuta, tista' tdaħħal kodiċi postali.",
        pt: "Se a janela não aparecer ou recusou, pode também introduzir um código postal.",
        sv: "Om dialogen inte visas eller du har nekat kan du även ange ett postnummer.",
        sk: "Ak sa dialóg neobjaví alebo ste odmietli, môžete zadať PSČ.",
    },
    aed_enter_plz: {
        lv: "Ievadīt pasta indeksu",
        lt: "Įveskite pašto kodą",
        mt: "Daħħal kodiċi postali",
        pt: "Introduzir código postal",
        sv: "Ange postnummer",
        sk: "Zadať PSČ",
    },
    aed_manual_title: {
        lv: "Ievadīt pasta indeksu",
        lt: "Įveskite pašto kodą",
        mt: "Daħħal kodiċi postali",
        pt: "Introduzir código postal",
        sv: "Ange postnummer",
        sk: "Zadať PSČ",
    },
    aed_manual_sub: {
        lv: "Atrašanās vietas piekļuve nav aktīva – ievadi pasta indeksu, lai atrastu defibrilatorus tuvumā.",
        lt: "Vietos prieiga neaktyvi – įveskite pašto kodą, kad rastumėte defibriliatorius netoliese.",
        mt: "L-aċċess għall-post mhux attiv – daħħal il-kodiċi postali biex issib defibrillaturi fil-qrib.",
        pt: "Acesso à localização inativo – introduza o seu código postal para encontrar desfibrilhadores próximos.",
        sv: "Platsåtkomst är inte aktiv – ange ditt postnummer för att hitta defibrillatorer i närheten.",
        sk: "Prístup k polohe nie je aktívny – zadajte PSČ a nájdite defibrilátory v okolí.",
    },
    aed_manual_hint: {
        lv: "Padoms: vari arī atkārtoti atļaut atrašanās vietu, ja pārlūks to atbalsta.",
        lt: "Patarimas: galite vėl įjungti vietos prieigą, jei naršyklė tai palaiko.",
        mt: "Suġġeriment: tista' tippermetti l-post mill-ġdid jekk il-browser jappoġġjah.",
        pt: "Dica: também pode ativar novamente o acesso à localização, se o navegador permitir.",
        sv: "Tips: du kan även tillåta platsåtkomst igen om webbläsaren stöder det.",
        sk: "Tip: prístup k polohe môžete znova povoliť, ak to prehliadač podporuje.",
    },
    aed_find_button: {
        lv: "Atrast defibrilatorus",
        lt: "Rasti defibriliatorius",
        mt: "Sib id-defibrillaturi",
        pt: "Encontrar desfibrilhadores",
        sv: "Hitta defibrillatorer",
        sk: "Nájsť defibrilátory",
    },
    aed_retry_gps: {
        lv: "Mēģināt GPS vēlreiz",
        lt: "Bandyti GPS dar kartą",
        mt: "Erġa' pprova l-GPS",
        pt: "Tentar GPS novamente",
        sv: "Försök GPS igen",
        sk: "Skúsiť GPS znova",
    },
    aed_toast_invalid_plz: {
        lv: "Lūdzu, ievadi derīgu 5 ciparu pasta indeksu.",
        lt: "Įveskite galiojantį 5 skaitmenų pašto kodą.",
        mt: "Jekk jogħġbok daħħal kodiċi postali validu ta' 5 ċifri.",
        pt: "Introduza um código postal válido de 5 dígitos.",
        sv: "Ange ett giltigt 5-siffrigt postnummer.",
        sk: "Zadajte platné 5-ciferné PSČ.",
    },
    aed_toast_plz_failed: {
        lv: "Pasta indeksu neizdevās atrast.",
        lt: "Pašto kodo nepavyko atpažinti.",
        mt: "Il-kodiċi postali ma setax jiġi solvut.",
        pt: "O código postal não pôde ser resolvido.",
        sv: "Postnumret kunde inte hittas.",
        sk: "PSČ sa nepodarilo nájsť.",
    },
    aed_toast_no_geo: {
        lv: "Pārlūks neatbalsta ģeolokāciju.",
        lt: "Naršyklė nepalaiko geografinės vietos.",
        mt: "Il-browser ma jappoġġjax il-ġeolokazzjoni.",
        pt: "O navegador não suporta geolocalização.",
        sv: "Webbläsaren stöder inte geolokalisering.",
        sk: "Prehliadač nepodporuje geolokáciu.",
    },
    aed_toast_geo_denied: {
        lv: "Atrašanās vietas atļauja noraidīta vai neizdevās.",
        lt: "Vietos prieiga atmesta arba nepavyko.",
        mt: "Il-permess għall-post ġie miċħud jew falla.",
        pt: "Permissão de localização recusada ou falhou.",
        sv: "Platsbehörighet nekad eller misslyckades.",
        sk: "Povolenie polohy bolo zamietnuté alebo zlyhalo.",
    },
    aed_placeholder_plz: {
        lv: "piem., 10115",
        lt: "pvz., 10115",
        mt: "eż. 10115",
        pt: "ex. 10115",
        sv: "t.ex. 10115",
        sk: "napr. 10115",
    },

    // ---------------- DEFIBRILLATOR MAP ----------------
    map_section_label: {
        lv: "Defibrilatori tuvumā",
        lt: "Defibriliatoriai netoliese",
        mt: "Defibrillaturi fil-qrib",
        pt: "Desfibrilhadores próximos",
        sv: "Defibrillatorer i närheten",
        sk: "Defibrilátory v okolí",
    },
    map_count: {
        lv: "{n} defibrilatoru atrašanās vietas",
        lt: "{n} defibriliatoriaus vietos",
        mt: "{n} lokazzjonijiet ta' defibrillaturi",
        pt: "{n} locais com desfibrilhadores",
        sv: "{n} defibrillatorplatser",
        sk: "{n} miest s defibrilátormi",
    },
    map_your_location: {
        lv: "Tava atrašanās vieta",
        lt: "Jūsų vieta",
        mt: "Il-lokazzjoni tiegħek",
        pt: "A sua localização",
        sv: "Din plats",
        sk: "Vaša poloha",
    },
    map_aed_label: {
        lv: "Defibrilators",
        lt: "Defibriliatorius",
        mt: "Defibrillatur",
        pt: "Desfibrilhador",
        sv: "Defibrillator",
        sk: "Defibrilátor",
    },
    map_you_are_here: {
        lv: "Tu esi šeit",
        lt: "Jūs esate čia",
        mt: "Int hawn",
        pt: "Você está aqui",
        sv: "Du är här",
        sk: "Ste tu",
    },
    map_operator: {
        lv: "Operators",
        lt: "Operatorius",
        mt: "Operatur",
        pt: "Operador",
        sv: "Operatör",
        sk: "Prevádzkovateľ",
    },
    map_indoor: {
        lv: "Iekštelpās",
        lt: "Viduje",
        mt: "Ġewwa",
        pt: "Interior",
        sv: "Inomhus",
        sk: "Vo vnútri",
    },
    map_outdoor: {
        lv: "Ārpus telpām",
        lt: "Lauke",
        mt: "Barra",
        pt: "Exterior",
        sv: "Utomhus",
        sk: "Vonku",
    },
    map_opening_hours: {
        lv: "Darba laiks",
        lt: "Darbo valandos",
        mt: "Ħinijiet ta' ftuħ",
        pt: "Horário",
        sv: "Öppettider",
        sk: "Otváracie hodiny",
    },

    // ---------------- COMMON ----------------
    tts_activate: {
        lv: "Aktivizēt balsi",
        lt: "Įjungti balsą",
        mt: "Attiva l-vuċi",
        pt: "Ativar voz",
        sv: "Aktivera röst",
        sk: "Zapnúť hlas",
    },
    tts_mute: {
        lv: "Izslēgt balsi",
        lt: "Išjungti balsą",
        mt: "Silenzja l-vuċi",
        pt: "Silenciar voz",
        sv: "Stäng av röst",
        sk: "Stlmiť hlas",
    },
    reset_link: {
        lv: "Sākt no jauna",
        lt: "Pradėti iš naujo",
        mt: "Ibda mill-ġdid",
        pt: "Recomeçar",
        sv: "Börja om",
        sk: "Začať odznova",
    },
    footer_powered_by: {
        lv: "Darbina SafetyAssist",
        lt: "Variklis: SafetyAssist",
        mt: "Mħaddem minn SafetyAssist",
        pt: "Desenvolvido por SafetyAssist",
        sv: "Drivs av SafetyAssist",
        sk: "Poháňa SafetyAssist",
    },
};
